/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC} from 'react'
import Breadcrumbs from '../../sharedComponent/Breadcrumbs/Breadcrumbs'
import {DashboardMetrics} from './DashboardMetrics'
import {TotalTPVList} from './TotalTPVList'

const TpvAdminDashboardPage: FC = () => (
  <>
    <Breadcrumbs title='Dashboard' subTitle='Home - Dashboard' />

    <DashboardMetrics />

    <TotalTPVList className='card-xxl-stretch ms-5 mb-xl-8' />
  </>
)

const TpvAdminDashboardWrapper: FC = () => {
  return (
    <>
      <TpvAdminDashboardPage />
    </>
  )
}

export {TpvAdminDashboardWrapper}
